module.exports = __webpack_public_path__ + "img/money11.9114eaf8.png";